import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WINDOW');

export const provideWindow = (window: Window) => {
  return { provide: WINDOW, useValue: window };
};
